<script setup lang="ts">
import { faWifi, faLinkSimple } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

const store = useAppStore();

function onClick() {
    document.getElementById('app-connect-btn')?.click();
}
</script>

<template>
        <UiFocusableButton
            autofocus
            class="bg-white"
            :label="store.app?.is_installable
                ? `Install ${store.app.name}`
                : (store.app?.connection_limit === 1
                    ? `Setup ${store.app.name}`
                    : `Connect to ${store.app.name}`)"
            :img="store.app?.icon"
            @click="onClick"
            bordered
        />
</template>